import { defaultMemoize, createSelectorCreator } from "reselect";

export const createSelector = createSelectorCreator(defaultMemoize, {
    maxSize: 5,
});
